module.exports = __webpack_public_path__ + "img/settings.8d0ca1c2.png";